var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("billingPage.PostageRechargeUploadTitle"),
        visible: _vm.dialogVisible,
        width: "560px",
        "destroy-on-close": "",
        "append-to-body": "",
        "before-close": _vm.hide,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.PostageRechargeInvoiceNo"),
                prop: "invoiceNumber",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t(
                    "billingPage.PostageRechargeInvoicePlaceholder"
                  ),
                },
                model: {
                  value: _vm.form.invoiceNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "invoiceNumber", $$v)
                  },
                  expression: "form.invoiceNumber",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.PostageRechargeIssueDate"),
                prop: "issueDate",
              },
            },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "date",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  placeholder: _vm.$t(
                    "billingPage.PostageRechargeSelectIssueDate"
                  ),
                },
                model: {
                  value: _vm.form.issueDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "issueDate", $$v)
                  },
                  expression: "form.issueDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.PostageRechargeCarrier"),
                        prop: "logisticsCompany",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.companyList,
                          placeholder: _vm.$t(
                            "billingPage.PostageRechargeSelectPartner"
                          ),
                        },
                        on: { change: _vm.handleCarrierChange },
                        model: {
                          value: _vm.form.logisticsCompany,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logisticsCompany", $$v)
                          },
                          expression: "form.logisticsCompany",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "billingPage.PostageRechargeFinancialAmount"
                        ),
                        prop: "financialAmount",
                      },
                    },
                    [
                      _c(
                        "BjInputMoney",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "billingPage.PostageRechargeFinancialAmountPlaceholder"
                            ),
                            "not-auto-zero": true,
                          },
                          model: {
                            value: _vm.form.financialAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "financialAmount", $$v)
                            },
                            expression: "form.financialAmount",
                          },
                        },
                        [_c("template", { slot: "prepend" }, [_vm._v("$")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "billingPage.PostageRechargeUpload" +
                    _vm.primaryFileFormat +
                    "File"
                ),
              },
            },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "invoice-upload",
                  attrs: {
                    drag: "",
                    action: "",
                    accept: _vm.getPrimaryUploadOptions().acceptTypes.join(","),
                    limit: 1,
                    "file-list": _vm.fileList,
                    "auto-upload": false,
                    "on-change": _vm.handleFileChange,
                    "on-exceed": _vm.handleFileExceed,
                    "on-remove": _vm.handleFileRemove,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v(
                      _vm._s(_vm.$t("billingPage.PostageRechargeDropFile"))
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "billingPage.PostageRechargeUpload" +
                                _vm.primaryFileFormat +
                                "Tip"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.requiresPdfAndCsv
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.PostageRechargeUploadCsvFile"),
                  },
                },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "csvUpload",
                      staticClass: "invoice-upload",
                      attrs: {
                        drag: "",
                        action: "",
                        accept: ".csv",
                        limit: 1,
                        "file-list": _vm.csvFileList,
                        "auto-upload": false,
                        "on-change": _vm.handleCsvFileChange,
                        "on-exceed": _vm.handleCsvFileExceed,
                        "on-remove": _vm.handleCsvFileRemove,
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("billingPage.PostageRechargeDropFile"))
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "billingPage.PostageRechargeUploadCsvTip"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.hide } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.confirmLoading },
              on: { click: _vm.confirm },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("billingPage.PostageRechargeUpload")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }